module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_31.5a4981d9.png";